import { render } from "./SegmentsTargetingCount.vue?vue&type=template&id=ef8d045c&scoped=true"
import script from "./SegmentsTargetingCount.vue?vue&type=script&lang=js"
export * from "./SegmentsTargetingCount.vue?vue&type=script&lang=js"

import "./SegmentsTargetingCount.vue?vue&type=style&index=0&id=ef8d045c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8d045c"]])

export default __exports__